import { requiredString } from '@utils/validation';
import { z } from 'zod';

export const schema = z.object({
	anythingElse: requiredString('Please provide a response of at least 50 characters', 50),
});
